/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductBenefitRequestModel } from '../../models/product-benefit-request-model';

export interface AdminProductBenefitListPost$Params {
      body?: ProductBenefitRequestModel
}

export function adminProductBenefitListPost(http: HttpClient, rootUrl: string, params?: AdminProductBenefitListPost$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, adminProductBenefitListPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<string>>;
    })
  );
}

adminProductBenefitListPost.PATH = '/Admin/ProductBenefitList';
